import React, { useState } from 'react';
import { DashboardLayout } from './DashboardLayout';
import { Button } from '../ui';
import { CalendarIcon, MapPinIcon, UsersIcon, PlusIcon, SearchIcon, FilterIcon, MoreVerticalIcon, ArrowRightIcon } from 'lucide-react';
export function EventsPage() {
  const [activeTab, setActiveTab] = useState('upcoming');
  const events = [{
    id: 1,
    name: 'Leadership Reset Retreat',
    location: 'Punta Cana, DR',
    date: 'May 12–14, 2026',
    attendees: 48,
    status: 'upcoming',
    image: 'https://images.unsplash.com/photo-1540544660406-6a69dacb2804?q=80&w=600&auto=format&fit=crop',
    progress: 75
  }, {
    id: 2,
    name: 'Q3 Sales Kickoff',
    location: 'Austin, TX',
    date: 'Aug 5–7, 2026',
    attendees: 120,
    status: 'upcoming',
    image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=600&auto=format&fit=crop',
    progress: 20
  }, {
    id: 3,
    name: 'Executive Offsite',
    location: 'Napa Valley, CA',
    date: 'Oct 10–12, 2026',
    attendees: 15,
    status: 'upcoming',
    image: 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?q=80&w=600&auto=format&fit=crop',
    progress: 5
  }, {
    id: 4,
    name: 'Annual Engineering Summit',
    location: 'Denver, CO',
    date: 'Jan 15–18, 2026',
    attendees: 85,
    status: 'past',
    image: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?q=80&w=600&auto=format&fit=crop',
    progress: 100
  }];
  const filteredEvents = events.filter(e => e.status === activeTab);
  return <DashboardLayout pageTitle="Events" data-id="element-1441">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8" data-id="element-1442">
        <div className="flex bg-slate-100 p-1 rounded-lg" data-id="element-1443">
          <button onClick={() => setActiveTab('upcoming')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${activeTab === 'upcoming' ? 'bg-white text-brand-navy shadow-sm' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-1444">
            Upcoming
          </button>
          <button onClick={() => setActiveTab('past')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${activeTab === 'past' ? 'bg-white text-brand-navy shadow-sm' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-1445">
            Past Events
          </button>
        </div>

        <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-1446">
          <div className="relative flex-1 sm:w-64" data-id="element-1447">
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-1448" />
            <input type="text" placeholder="Search events..." className="w-full pl-9 pr-4 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-teal/20 focus:border-brand-teal" data-id="element-1449" />
          </div>
          <Button variant="outline" size="sm" className="px-3" data-id="element-1450">
            <FilterIcon className="w-4 h-4" data-id="element-1451" />
          </Button>
          <Button variant="primary" size="sm" data-id="element-1452">
            <PlusIcon className="w-4 h-4 mr-2" data-id="element-1453" />
            New Event
          </Button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1454">
        {filteredEvents.map(event => <div key={event.id} className="bg-white rounded-2xl shadow-soft border border-slate-100 overflow-hidden group hover:shadow-lg transition-shadow" data-id="element-1455">
            <div className="h-40 relative overflow-hidden" data-id="element-1456">
              <img src={event.image} alt={event.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1457" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-1458" />
              <div className="absolute bottom-4 left-4 right-4 flex justify-between items-end" data-id="element-1459">
                <span className="bg-white/20 backdrop-blur-md text-white text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-1460">
                  {event.status === 'upcoming' ? 'Planning' : 'Completed'}
                </span>
                <button className="text-white hover:bg-white/20 p-1 rounded-md backdrop-blur-sm transition-colors" data-id="element-1461">
                  <MoreVerticalIcon className="w-5 h-5" data-id="element-1462" />
                </button>
              </div>
            </div>
            <div className="p-5" data-id="element-1463">
              <h3 className="text-lg font-bold text-brand-navy mb-3 line-clamp-1" data-id="element-1464">
                {event.name}
              </h3>
              <div className="space-y-2 mb-6" data-id="element-1465">
                <div className="flex items-center gap-2 text-sm text-slate-600" data-id="element-1466">
                  <CalendarIcon className="w-4 h-4 text-slate-400" data-id="element-1467" />
                  {event.date}
                </div>
                <div className="flex items-center gap-2 text-sm text-slate-600" data-id="element-1468">
                  <MapPinIcon className="w-4 h-4 text-slate-400" data-id="element-1469" />
                  {event.location}
                </div>
                <div className="flex items-center gap-2 text-sm text-slate-600" data-id="element-1470">
                  <UsersIcon className="w-4 h-4 text-slate-400" data-id="element-1471" />
                  {event.attendees} Attendees
                </div>
              </div>

              {event.status === 'upcoming' && <div className="mb-5" data-id="element-1472">
                  <div className="flex justify-between text-xs mb-1.5" data-id="element-1473">
                    <span className="text-slate-500 font-medium" data-id="element-1474">
                      Setup Progress
                    </span>
                    <span className="text-brand-navy font-bold" data-id="element-1475">
                      {event.progress}%
                    </span>
                  </div>
                  <div className="w-full bg-slate-100 rounded-full h-1.5" data-id="element-1476">
                    <div className="bg-brand-teal h-1.5 rounded-full" style={{
                width: `${event.progress}%`
              }} data-id="element-1477" />
                  </div>
                </div>}

              <Button variant="outline" className="w-full justify-between group/btn" data-id="element-1478">
                Manage Event
                <ArrowRightIcon className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" data-id="element-1479" />
              </Button>
            </div>
          </div>)}

        {activeTab === 'upcoming' && <div className="bg-slate-50 rounded-2xl border-2 border-dashed border-slate-200 flex flex-col items-center justify-center p-8 text-center hover:bg-slate-100 transition-colors cursor-pointer min-h-[380px]" data-id="element-1480">
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm mb-4" data-id="element-1481">
              <PlusIcon className="w-6 h-6 text-brand-teal" data-id="element-1482" />
            </div>
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-1483">
              Create New Event
            </h3>
            <p className="text-sm text-slate-500 max-w-[200px]" data-id="element-1484">
              Start planning your next retreat, offsite, or meeting.
            </p>
          </div>}
      </div>
    </DashboardLayout>;
}